import { render, staticRenderFns } from "./HeaderProfile.vue?vue&type=template&id=32864314"
import script from "./HeaderProfile.vue?vue&type=script&lang=js"
export * from "./HeaderProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports